export default __webpack_public_path__ + "static/media/youngmale.8c3bdfce.svg";